// i18n area 'storage' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.hr-HR.meta.json.
import type { enUS } from './storage'

export const hrHR: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Stvorite storage',
      path: 'Putanja',
      pathHint: 'Apsolutna putanja pod dopuštenim rootom (zadano /var/lib/tvirt/pools/)',
      shared: 'Dijeljeni storage',
      sharedChip: 'dijeljeno',
      sharedVerifiedChip: 'dijeljeno · provjereno',
      sharedVerifiedTooltip: 'Dijeljenje provjereno: unakrsne sonde potvrđuju da svaki član vidi podatke koje su zapisali drugi.',
      sharedDisputedChip: 'dijeljeno · NIJE provjereno',
      sharedDisputedTooltip: 'Dijeljenje NIJE provjereno',
      sharedDisputedPair: '{observer} ne vidi podatke koje je zapisao {writer}',
      sharedHint: 'Mrežni share montiran lokalno na istoj putanji na svakom članu — preduvjet live migracije (deklarativno).',
      sharedDanger: 'OPASNOST — TVirt VJERUJE ovoj zastavici: uključite li je, svaki član pretpostavlja da na ovoj putanji vidi ISTE bajtove. Na mapi koja NIJE stvarno dijeljeni share (NFS/CIFS/klasterski datotečni sustav) rezultat je oštećenje i gubitak podataka pri prvoj migraciji ili prvom HA ponovnom pokretanju na drugom čvoru. Uključite je samo ako je putanja share montiran identično na svakom čvoru.',
      type: 'Tip',
      capacity: 'Kapacitet',
      provisioned: 'Dodijeljeno',
      provisionedOvercommit: 'Potencijalna obveza iznad kapaciteta: thin volumeni mogu narasti do {n} GiB.',
      phase: { ready: 'Spreman', degraded: 'Degradiran', error: 'Pogreška' },
      tabConfig: 'Konfiguracija',
      tabCapacity: 'Kapacitet i stanje',
      cardIdentity: 'Identitet',
      cardPlacement: 'Smještaj',
      cardConnection: 'Veza',
      usedReal: 'Stvarna zauzetost',
      capacityUnknown: 'Čvor još nije izvijestio o kapacitetu ovog poola — ovdje se brojevi ne izmišljaju',
      overcommitHint: 'Obveza iznad kapaciteta: legitimno na thin poolovima, pripazite na stvarnu zauzetost',
      supportedContent: 'Podržani sadržaji',
      content: {
        disks: 'Diskovi',
        catalogFiles: 'Datoteke kataloga',
        backups: 'Backupi',
        appVolumes: 'Volumeni aplikacija'
      },
      defaultDiskFormat: 'Zadani format diska',
      reserveGiB: 'Rezervirani slobodni prostor (GiB)',
      available: 'Dostupno',
      diskCount: 'Diskovi',
      filesystem: 'Datotečni sustav',
      observedAt: 'Promatrano',
      lostAtRow: 'Proglašeno izgubljenim',
      sharedProbeRow: 'Provjera dijeljenja',
      sharedProbeNodes: 'Sondirani čvorovi',
      reachableFrom: 'Deklarirana dostupnost',
      reachableFromHint: 'Čvorovi s kojih ovaj storage mora biti dostupan. VM čiji diskovi, ISO slike ili metapodaci žive ovdje neće se pokrenuti niti migrirati na čvor izvan ovog popisa. Svi članovi su unaprijed odabrani: suzite po želji. Čvor koji poslije uđe u klaster ostaje izvan dok ga ovdje ne dodate.',
      reachableFromNone: 'nije deklarirana',
      reachableFromTags: 'Dostupnost po tagovima',
      reachableFromTagsHint: 'Selektor tag=vrijednost (stavke odvojene zarezom, u AND-u): svaki član koji nosi ove tagove deklariran je dostupnim — dinamički: tagiranje čvora ga uvodi.',
      reachableFromTagsInvalid: 'Neispravan format — koristite tag=vrijednost, odvojeno zarezom',
      reachableResolved: 'Razriješeni čvorovi: {nodes}',
      reachableDeclaredNotSeen: 'deklarirano, ali sonda dijeljenja nije vidjela na: {nodes}',
      reachableSeenNotDeclared: 'viđeno, ali nije deklarirano (izvan perimetra) na: {nodes}',
      cephCluster: 'Upravljani Ceph klaster',
      appGuardTitle: 'Storage u uporabi kod aplikacija',
      appEphemeralGuard: 'ovaj storage je klasterski privremeni pool aplikacija — najprije ga promijenite sa stranice Aplikacije, zatim ga izbrišite.',
      appInUseGuard: 'ovdje žive rootovi/volumeni aplikacija: {apps} — najprije ih premjestite ili izbrišite.',
      releaseRequiredTitle: "Izbrisati '{name}' i osloboditi njegove slike?",
      releaseRequiredBatchTitle: 'Izbrisati odabrane storage i osloboditi njihove slike?',
      releaseRequiredBody: 'Oslobađanje slika ne briše NIJEDAN bajt: odjava ostavlja namespace na disku, slike jednostavno prestaju biti materijalizirane i svaka referenca scopeova preživljava kao claim — ponovno registrirajte pool i bit će ponovno usvojene.',
      releaseConfirm: 'Izbriši i oslobodi slike'
    },
    lost: {
      chip: 'Izgubljen',
      action: 'Proglasi izgubljenim',
      confirmTitle: 'Proglasite storage izgubljenim',
      confirmBody: 'Izjava operatera na vlastitu deklariranu odgovornost: svaki zadatak u redu čekanja ili u tijeku nad ovim storageom ili njegovim objektima NEĆE USPJETI, brisanja postaju samo evidencijska (bez rada na datotečnom sustavu), a novi se fizički rad odbija. Bajtovi se nikad ne diraju — vrati li se podloga u život, registrirajte je ponovno i pokrenite skeniranje da sve ponovno usvojite.',
      confirmSubmit: 'Proglasi izgubljenim',
      error: 'Izjava je odbijena'
    },
    findings: {
      action: 'Pronađeni objekti',
      title: 'Pronađeni objekti',
      empty: 'U namespaceu storagea nije pronađen nijedan objekt',
      loadError: 'Pronađene objekte nije moguće učitati',
      actionError: 'Odluka je odbijena',
      colKind: 'Tip',
      colObject: 'Objekt',
      colConflict: 'Sukob',
      namespaceNotice:
        'Ovaj direktorij već je inicijalizirao drugi storage: identitetski pečat prepisan je pečatom ovog storagea. Sadržaj NIJE diran — pregledaj pronađene objekte ispod, uvezi one koji ti trebaju, a zatim odbaci ovu obavijest.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Datoteka kataloga',
        vmMetadata: 'VM metapodaci',
        namespace: 'Namespace',
        foreign: 'Strano',
        volumeGroup: 'Grupa volumena'
      },
      vgAdopt: {
        action: 'Usvoji grupu volumena',
        title: 'Usvoji grupu volumena',
        intro:
          'Ovaj uređaj već nosi grupu volumena s imenom TVirta, ali njezin pečat ne imenuje nijedan ovdje registriran storage. Može biti ono što je prethodni storage OVOG klastera ostavio na LUN-u — ili ono što je DRUGI TVirt klaster ostavio na LUN-u koji je promijenio vlasnika: odavde oba slučaja izgledaju jednako, i zato nitko ne odlučuje umjesto vas.',
        irreversible: 'Pogledajte uređaj, pečat i ime prije nego nastavite: usvajanje se ne može poništiti.',
        device: 'Uređaj',
        seal: 'Pečat',
        sealNone: 'nema (nema oznake tvirt.storageId)',
        renameTo: 'Bit će preimenovana u',
        renameNone: 'Bez preimenovanja: ime je već ono koje ovaj storage izvodi',
        volumesNote:
          'Sadržani volumeni se ovom gestom NE usvajaju: sljedeće skeniranje nudi ih jedan po jedan, kao obične pronađene objekte.'
      },
      conflictChip: 'ID već postoji',
      dismissedChip: 'Zanemareno',
      adopt: 'Usvoji',
      adoptFileTitle: 'Uvezite u katalog',
      adoptFileHint: 'Datoteke postoje samo unutar kataloga: odaberite odredišni katalog za pronađenu datoteku.',
      purge: 'Izbriši s diska',
      dismiss: 'Zanemari',
      purgeConfirmTitle: 'Izbrišite s diska',
      purgeConfirmBody: 'Pronađeni bajtovi objekta {id} bit će uklonjeni sa storagea. Radnja se ne može poništiti.',
      taskStarted: 'Pokrenuto — nastavlja se kao zadatak u pozadini',
      scan: 'Skeniraj storage',
      scanStarted: 'Skeniranje pokrenuto…',
      scanDone: 'Skeniranje dovršeno — pronađeni objekti su ažurni'
    },
    reinit: {
      action: 'Ponovno pokušaj inicijalizaciju'
    },
    wizard: {
      addButton: 'Dodaj',
      title: 'Dodajte storage',
      back: 'Natrag',
      continue: 'Nastavi',
      selectHint: 'Odaberite protokol da vidite kako ga TVirt koristi.',
      roadmap: 'Roadmap',
      server: 'Poslužitelj',
      export: 'Izvezena putanja',
      share: 'Share',
      username: 'Korisničko ime',
      password: 'Lozinka',
      passwordHint: 'Samo za upis: koristi se za montiranje i više se nikad ne prikazuje.',
      credential: 'Vjerodajnica',
      credentialManual: 'Unesi ručno',
      credentialHint: 'Keystore stavka tipa korisničko ime i lozinka — alternativa upisivanju ovdje.',
      credentialEmpty: 'U keystoreu još nema vjerodajnice tipa korisničko ime i lozinka — stvorite je pod Sustav → Vjerodajnice ili upišite račun ovdje ispod.',
      options: 'Opcije montiranja',
      optionsHint: 'Odvojene zarezom, prosljeđuju se mount -o doslovno.',
      portal: 'Portal',
      portalHint: 'host[:port] — zadani port je 3260.',
      target: 'Target IQN',
      targetHint: 'Naziv iSCSI targeta, počinje s iqn.',
      lun: 'LUN',
      wholeLunRow: 'Na diskovima: ovaj storage imenuje samo target',
      wholeLunHint: 'Ovaj storage imenuje samo target: njegovi LUN-ovi postaju diskovi jedan po jedan (Stvori disk → preuzmi cijeli LUN), na target se ništa ne piše.',
      lunHint: 'Broj LUN-a na targetu — 0 ako niste sigurni.',
      chapCredential: 'Vjerodajnica (CHAP)',
      chapCredentialHint: 'Keystore stavka tipa CHAP (iSCSI) koja se koristi za prijavu — tajna nikad ne putuje sa storageom.',
      chapNone: 'Bez autentifikacije',
      chapEmpty: 'U keystoreu još nema CHAP (iSCSI) vjerodajnice — stvorite je pod Sustav → Vjerodajnice. Bez nje prijava ostaje neautentificirana.',
      address: 'Adresa',
      addressHint: 'Host ili IP NVMe/TCP targeta (traddr).',
      port: 'Port',
      portHint: 'TCP port targeta — 4420 ako ostane prazno.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN subsystema na targetu, počinje s nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID unutar subsystema — 1 ako niste sigurni.',
      dhchapCredential: 'Vjerodajnica (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Keystore stavka tipa DH-HMAC-CHAP (NVMe) koja se koristi pri spajanju — tajna nikad ne putuje sa storageom.',
      dhchapNone: 'Bez autentifikacije',
      dhchapEmpty: 'U keystoreu još nema DH-HMAC-CHAP (NVMe) vjerodajnice — stvorite je pod Sustav → Vjerodajnice. Bez nje veza ostaje neautentificirana.',
      monitors: 'Monitori',
      monitorsHint: 'Endpointi Ceph monitora, host[:port], odvojeni zarezom ili novim retkom — zadani port je 6789.',
      pool: 'Pool',
      poolHint: 'RBD pool koji se koristi — jedna RBD slika po disku.',
      fs: 'Datotečni sustav',
      fsHint: 'Naziv CephFS datotečnog sustava (mds_namespace pri montiranju).',
      fsPath: 'Putanja unutar datotečnog sustava',
      fsPathHint: 'Apsolutna putanja unutar datotečnog sustava koju storage montira — / ako niste sigurni.',
      cephxCredential: 'Vjerodajnica (cephx)',
      cephxCredentialHint: 'Keystore stavka tipa cephx: username = ime klijenta (client.…), secret = base64 ključ. Obavezna.',
      cephxNone: 'U keystoreu još nema cephx vjerodajnice — stvorite jednu (tip: cephx) pod Sustav → Vjerodajnice, ili prepustite da je upravljani Ceph klaster iskuje putem "Predloži kao storage".',
      sharedByNature: 'Mrežni storage dijeljen je po prirodi: svaki ga član montira na istoj putanji kojom upravlja TVirt.',
      error: 'Storage je odbijen',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Ostalo',
        legacy: 'Legacy'
      },
      legacyHint: 'Potpuno podržani — samo ih ne bismo odabrali za novu instalaciju.',
      proto: {
        dir: {
          name: 'Lokalna mapa',
          desc: 'Direktorij na čvoru: jednostavno i brzo. LOKALAN je jednom čvoru, osim ako putanja nije stvarno dijeljeni share — označiti ga dijeljenim kad to nije plaća se podacima.',
          usage: 'TVirt u njemu čuva diskove VM-ova, ISO/disk slike i predloške.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS export koji klaster montira — dijeljen po prirodi.',
          usage: 'Sadrži diskove VM-ova, ISO/disk slike i predloške.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Windows/Samba share koji klaster montira — dijeljen po prirodi.',
          usage: 'Sadrži diskove VM-ova, ISO/disk slike i predloške.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Udaljeni datotečni sustav preko SSH-a — bez potrebe za NAS exportom.',
          usage: 'Na roadmapu.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokovski LUN-ovi preko IP-a s dijeljenim LVM-om povrh.',
          usage: 'Samo diskovi — jedan thin volumen po disku; ne sadrži ISO slike ni predloške.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Distribuirani blok uređaji na Ceph klasteru.',
          usage: 'Samo diskovi — jedna RBD slika po disku, koju QEMU otvara nativno; ne sadrži ISO slike.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Cephov distribuirani datotečni sustav, montiran kernelom na klasteru — shared by nature.',
          usage: 'Sadrži VM diskove, ISO/disk slike i predloške — obitelj dir na Ceph datotečnom sustavu (cephx vjerodajnica obavezna).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN-ovi preko FibreChannel fabrica — klasični FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Isti SCSI preko FibreChannela, s FC okvirima enkapsuliranima u Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (cijeli LUN-ovi)',
          desc: 'iSCSI target kao nositelj cijelih LUN-ova: svaki disk JEST LUN, sirovo predan gostu — bez LVM-a između.',
          usage: 'Samo diskovi — jedan cijeli LUN po disku, preuzet kakav jest; SAN dom diskova s dijeljenim pisanjem.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (cijeli namespacei)',
          desc: 'NVMe podsustav kao nositelj cijelih namespacea: svaki disk JEST namespace, sirovo predan gostu.',
          usage: 'Samo diskovi — jedan cijeli namespace po disku, preuzet kakav jest; dijeljeno pisanje da, SCSI persistent reservations ne.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Udaljeni NVMe — bez SCSI-ja na putu — preko običnog TCP-a, s dijeljenim LVM-om povrh.',
          usage: 'Samo diskovi — jedan thin volumen po disku; ne sadrži ISO slike ni predloške.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Udaljeni NVMe preko FibreChannel fabrica.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe preko FibreChannel fabrica koji FCoE prenosi unutar Etherneta — slojevi FCoE i NVMe/FC naslagani.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI s podatkovnim putem premještenim na RDMA — bilo koji fabric (InfiniBand, iWARP, RoCE). Nadmašen NVMe/RDMA-om, još prisutan u arrayima i u ESXi-ju.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Nativni SCSI preko RDMA, era prije iSER-a: InfiniBand (s discoveryjem fabrica) i RoCE — preživljava u ostarjelim HPC storageima.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Udaljeni NVMe preko bilo kojeg RDMA fabrica — InfiniBand, iWARP, RoCE v1 i v2: jedna jedina konfiguracija, čvor javlja koji ima.' },
        s3: { name: 'S3', desc: 'Object storage kompatibilan sa S3 — slike i sigurnosne kopije.' }
      }
    },
    catalogs: {
      title: 'Katalozi',
      createTitle: 'Stvorite katalog',
      editTitle: 'Uredite katalog',
      docTitle: 'Katalog',
      notFound: 'Ovaj katalog ne postoji (više?)',
      scopeHint: 'Tko čita ovaj scope, vidi (i može koristiti) svaku datoteku kataloga',
      files: 'Datoteke',
      noFiles: 'Nema datoteka',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'sustavski',
      systemTooltip: 'Sustavski katalog: sadrži ugrađene objekte platforme i ne može se mijenjati'
    },
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Tip',
      physicalSize: 'Fizička veličina',
      virtualSize: 'Virtualna veličina',
      importTemplateAction: 'Uvezi kao VM predložak',
      importTemplateLegacy: 'Nema deklariranog formata — upotrebljivo kao seed za diskove, nije uvozivo',
      importTemplateTitle: 'Uvezite kao VM predložak',
      importTemplateSubmit: 'Uvezi',
      importTemplateError: 'Uvoz nije uspio',
      importTemplateHint: 'Paket .tvtpl postaje VM predložak: zamrznuti hardver iz manifesta plus jedan disk po stavci arhive, svaki provjeren prema svojem checksumu. NIC-ovi i CD/DVD mediji nisu dio arhive — dodajte ih nakon uvoza.',
      importTemplateQcow2Hint: 'Goli qcow2 postaje predložak s JEDNIM diskom i deklariranim zadanim hardverom: linux profil, UEFI, 2 vCPU, 2048 MiB, boot s njegova jedinog diska. Prilagodite pri implementaciji.',
      importTemplateName: 'Naziv predloška',
      importTemplateNameHint: 'Prazno = {name} (-import-<n> ako je zauzeto)',
      importTemplateStorage: 'Storage za diskove',
      importTemplateMetadataStorage: 'Storage za metapodatke',
      importTemplateMetadataHint: 'Blokovski storage ne sadrži VM metapodatke (firmware, varstore) — odaberite neki dir/nfs/cifs.',
      importTemplateStarted: 'Uvoz pokrenut — predložak se pojavljuje u kartici Predlošci po završetku zadatka.',
      kind: {
        iso: 'ISO slika',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM predložak',
        'oci-image': 'OCI slika',
        'firmware-ovmf': 'OVMF firmware'
      },
      title: {
        iso: 'ISO slike',
        'ct-rootfs': 'CT predlošci',
        'vm-template': 'VM predlošci',
        'oci-image': 'OCI slike',
        'firmware-ovmf': 'OVMF firmware'
      },
      createTitle: {
        iso: 'Dodajte ISO sliku',
        'ct-rootfs': 'Registrirajte CT predložak',
        'vm-template': 'Dodajte VM predložak',
        'oci-image': 'Dodajte OCI sliku',
        'firmware-ovmf': 'Dodajte OVMF firmware'
      },
      formatHint: 'Izveden iz ekstenzije odabrane datoteke — ispravite ako je krivo pogodio',
      tarballHint: 'Rootfs tarball u standardnom LXC formatu (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, ili običan .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar ili .tar.gz), npr. iz docker save',
      uploadResumeHint: 'Prijenos prekinut — datoteka čeka prijenos: pošaljite ponovno istu datoteku za nastavak',
      moveTitle: 'Premjestite datoteku',
      moveHint: 'Dvije neovisne dimenzije: Katalog premješta poveznicu (isti id, nijedan bajt se ne miče, scope postaje onaj odredišnog kataloga); Storage premješta podatke — svaka povezana kopija slijedi, odbija se dok je datoteka u uporabi. Odabrani zajedno: prvo katalog, pa storage.',
      moveCatalog: 'Odredišni katalog',
      moveCatalogHint: 'Samo poveznica mijenja dom: VM koji je montirao datoteku mora moći vidjeti odredišni katalog',
      keepCurrent: 'Ne mijenjaj',
      rehomed: 'Poveznica premještena u odabrani katalog',
      copyAction: 'Kopiraj u katalog…',
      copyTitle: 'Kopirajte u katalog',
      copyLinkHint: 'Kopija je nova poveznica na iste podatke — ništa se ne duplicira na storageu.',
      copyCatalog: 'Odredišni katalog',
      copyCatalogHint: 'Kopiranje je način na koji datoteka putuje između kataloga',
      sameCatalog: 'Isti kao izvor',
      sharedObjectHint: 'Podatke ove datoteke dijele povezane kopije — ukupno: {count}',
      deleteLastLink: 'Ovo je POSLJEDNJA poveznica na ovaj sadržaj: sa storagea će se izbrisati i podaci.',
      deleteLinkOnly: 'Uklonit će se samo ova poveznica — podaci ostaju, i dalje dostupni kroz ostale povezane kopije ({count}).',
      noCatalog: 'Još nema nijednog kataloga — stvorite jedan',
      inlineCatalogName: 'Naziv kataloga',
      embeddedChip: 'ugrađeno',
      embeddedStorage: 'Ugrađeno u platformu',
      embeddedNoMove: 'Ugrađena datoteka platforme: ne živi ni na jednom storageu — umjesto toga je klonirajte',
      embeddedCopyHint: 'Klon materijalizira ugrađene bajtove na stvarni storage: odaberite odredišni storage i katalog — kopija je obična datoteka',
      sourceEmbedded: 'Ugrađeno u platformu',
      nodesRow: 'Prisutnost po čvoru',
      nodesSummary: '{present} od {total} čvorova ga ima',
      nodePresent: 'prisutan',
      nodeMissing: 'nedostaje',
      nodeUnknown: 'još nije prijavljeno',
      nodesHint: 'Resurs živi na disku svakog čvora (paket trantor-tvirt-assets): čvor koji ga nema ne može ni definirati VM s ovim firmverom ni posluživati Guest Tools. Različite verzije među čvorovima normalne su tijekom postupnog ažuriranja.',
      downloadAction: 'Preuzmi',
      downloadNotReady: 'Sadržaj još nije spreman — preuzimanje zahtijeva datoteku u stanju ready',
      downloadDenied: 'Vaša uloga ne uključuje catalog.download — preuzimanje bajtova zasebno je pravo, odvojeno od korištenja datoteke',
      objectRow: 'Storage objekt',
      objectLinksRow: 'Povezane kopije',
      declaredChecksum: 'Deklarirani SHA-256',
      usedByRow: 'Koriste',
      usedByVms: 'VM-ovi',
      usedByDisks: 'Diskovi',
      transferRow: 'Prijenos',
      storageLockHint: 'Mijenja se samo radnjom Premjesti'
    },
    objects: {
      action: 'Istraži sadržaj',
      title: 'Sadržaj storagea',
      hint: 'Popis samo za čitanje svega što živi na ovom storageu — svakim se objektom upravlja iz njegova odjeljka.',
      empty: 'Ništa nije registrirano na ovom storageu',
      loadError: 'Sadržaj nije moguće učitati',
      colDetail: 'Detalj',
      manage: 'Upravljaj u pripadnom odjeljku',
      kind: {
        disk: 'Disk',
        catalogFile: 'Datoteka kataloga',
        ociBlob: 'OCI blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM metapodaci',
        appRoot: 'Root aplikacije',
        appVolume: 'Volumen aplikacije'
      }
    },
    inventory: {
      tabCatalogs: 'Katalozi',
      storage: 'Storage',
      sizeGib: 'Veličina (GiB)',
      format: 'Format',
      size: 'Veličina',
      sourceType: 'Izvor',
      sourceFile: 'Prijenos datoteke',
      sourceUrl: 'Preuzimanje s URL-a',
      file: 'Datoteka',
      url: 'URL',
      checksum: 'SHA-256 checksum',
      checksumHint: 'Obavezno: preuzimanje se provjerava prema ovom SHA-256',
      verifyChecksum: 'Provjeri checksum',
      checksumOffHint: 'Preuzimanje će biti prihvaćeno bez provjere — izračunati SHA-256 svejedno se bilježi',
      uploading: 'Prijenos u tijeku…',
      move: {
        action: 'Premjesti',
        diskTitle: 'Premjestite disk',
        target: 'Odredišni storage',
        diskHint: 'Disk zadržava svoj identitet: bajtovi putuju na odabrani storage. VM koji ga koristi mora biti isključen; s prisutnim snimkama iSCSI strana odbija premještanje.',
        noTargets: 'Nema kompatibilnog odredišnog storagea',
        submit: 'Premjesti',
        error: 'Premještanje je odbijeno'
      },
      clone: {
        action: 'Kloniraj',
        title: 'Klonirajte disk',
        name: 'Naziv kopije',
        storage: 'Odredišni storage',
        sameStorage: 'Isti kao izvor',
        linked: 'Linked clone',
        linkedHint: 'Trenutačni qcow2 overlay ulančan na izvorni disk (samo qcow2 izvori). Zadano je potpuna kopija.',
        linkedCrossHint: 'Linked clone mora ostati na izvornom storageu: odaberite "Isti kao izvor" da ga omogućite.',
        submit: 'Kloniraj',
        error: 'Kloniranje je odbijeno'
      },
      copy: {
        action: 'Kopiraj',
        name: 'Naziv kopije',
        storage: 'Odredišni storage',
        sameStorage: 'Isti kao izvor',
        submit: 'Kopiraj',
        error: 'Kopiranje je odbijeno'
      },
      taskStarted: 'Pokrenuto — nastavlja se kao zadatak u pozadini',
      cephObjects: 'Idi na detalje objekta na Cephu',
      phase: {
        ready: 'Spremna',
        creating: 'Stvara se',
        'awaiting-upload': 'Čeka prijenos',
        downloading: 'Preuzima se',
        verifying: 'Provjerava se',
        deleting: 'Briše se',
        error: 'Pogreška',
        'in-use': 'U uporabi'
      }
    }
  }
}
